import React, { useCallback, useEffect } from "react";
import check from "../../assets/images/check.svg";
import {
  closeThanksPopup,
  openLoginModal,
} from "../../features/slices/ModalSlice";
import { updateSelectedItem } from "../../features/slices/CommonSlice";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";

export default function Thanks({ onClose }) {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const dispatch = useDispatch();
  const thanksPopupConfig = useSelector((state) => state.modal.thanksPopupConfig);

  const handleClose = useCallback(() => {
    dispatch(closeThanksPopup());
    if (onClose) {
      onClose();
      return;
    }
    if (thanksPopupConfig.redirectToLogin) {
      if (isMobile) {
        dispatch(updateSelectedItem("login"));
      } else {
        dispatch(openLoginModal("login"));
      }
    }
  }, [dispatch, isMobile, onClose, thanksPopupConfig.redirectToLogin]);

  useEffect(() => {
    const timer = setTimeout(handleClose, 3000);
    return () => clearTimeout(timer);
  }, [handleClose]);

  return (
    <div>
      <div
        className={`modal fade show otp--modal`}
        style={{
          display: "block",
          backdropFilter: "blur(15px)",
          animation: "fadeIn 0.3s ease-in-out",
        }}
        tabIndex="-1"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h2 className="modal-title fs-5"></h2>
              <i onClick={handleClose} className="bi bi-x-lg"></i>
            </div>
            <div className="modal-body mobile-otp-modal--body text-center">
              <div className="text-center">
                <img
                  loading="lazy"
                  src={check}
                  alt="verification-complete"
                  width={80}
                />
                <p className="text---large mt-4">{thanksPopupConfig.title}</p>
                <p className="text-muted text--medium">
                  {thanksPopupConfig.message}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
        .modal {
          animation: fadeIn 0.3s ease-in-out;
        }
      `}</style>
    </div>
  );
}
